export const floatingActions = {
	massEdit: "Edición masiva de productos",
	editExcel: "Editar vía Excel",
	testFiscal: "Probar integración fiscal",
	testFiscalData: "Probar datos fiscales",
	syncWithDelivery: "Sincronizar con delivery",
	deleteSelected: "Eliminar productos seleccionados",
	activateSelected: "Activar productos seleccionados",
	deactivateSelected: "Desactivar productos seleccionados",
	selectedProduct: "Producto seleccionado",
	selectedProducts: "Productos seleccionados",
};
